import { Pipe, PipeTransform } from '@angular/core';
import * as FORM from '../model/rule-form-grouping.model';
import { isFORMSet, RULESET_NAMES } from '../model/constants';
import { AppService } from '@cv-invision/core';

@Pipe({ name: 'orderRuleBy' })
export class OrderRuleBy implements PipeTransform {
	constructor(private appService: AppService) { }
	/**
	 * Sort by property (root level, only)
	 * @param array
	 * @param field
	 */
	transform(array: any, formType: string): any[] {
		const SCHEMA_CONFIG = this.appService.getSchemaConfig().SCHEMA_CONFIG;
		const SIMPLIFIED_NAV_FORMS_SET = this.appService.getSchemaConfig().SIMPLIFIED_NAV_CONFIG_SETS.forms;

		if (!Array.isArray(array)) {
			return [];
		}
		let form;
		// get form rules order
		switch (formType) {
			case SCHEMA_CONFIG?.CVReview_1004?.formType:
				form = FORM.form1004;
				break;
			case SCHEMA_CONFIG?.CVReview_1073?.formType:
			case SCHEMA_CONFIG?.CVReview_1075?.formType:
				form = FORM.form107375;
				break;
			case SCHEMA_CONFIG?.CVReview_2055?.formType:
				form = FORM.form2055;
				break;
			case SCHEMA_CONFIG?.FNMA?.formType:
				form = FORM.formFNMA;
				break;
			case SCHEMA_CONFIG?.InspectionReport?.formType:
				form = FORM.simplifiedRuleGroupingView;
				break;
		}

		if (formType && ((isFORMSet(formType) || SIMPLIFIED_NAV_FORMS_SET.has(formType)))) {
			form = FORM.simplifiedRuleGroupingView;
		}

		let groupingRules = [];

		(form || []).forEach(s => {
			// get rules by section
			const filterd = array.filter(r => {
				const multiUiSections = r.multipleUiSections || [];
				if (
					multiUiSections &&
					multiUiSections.length
				) {
					if (multiUiSections[0].uiSection.toLowerCase() === s) {
						return r;
					}
				}

				// sometimes we not get  multipleUiSections value but uisection
				if (multiUiSections.length < 1 && r.uiSection.toLowerCase() === s) {
					return r;
				}
			});
			// sorting  by individual section
			filterd.sort((a: any, b: any) => {
				const isOverview = s === 'overview';

				if (isOverview) {
					const aIsPost = (a.ruleSetName || '').toUpperCase() === RULESET_NAMES.POST_REVISION;
					const bIsPost = (b.ruleSetName || '').toUpperCase() === RULESET_NAMES.POST_REVISION;

					// POST_REVISION always first inside OVERVIEW
					if (aIsPost !== bIsPost) return aIsPost ? -1 : 1;
				}

				if (a.cvSortId < b.cvSortId) {
					return -1;
				} else if (a.cvSortId > b.cvSortId) {
					return 1;
				} else {
					return 0;
				}
			});

			if (filterd.length) {
				groupingRules = [...groupingRules, ...filterd];
			}
		});

		return groupingRules;
	}
}
